// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IVerifyCode } from '~/utils/interface/verifyCode';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      code: yup.array().length(6).required(t('common_validate_field_required')),
    })
    .required();
};

export const defaultValuesForm: IVerifyCode = {
  code: [EMPTY_STRING, EMPTY_STRING, EMPTY_STRING, EMPTY_STRING, EMPTY_STRING, EMPTY_STRING],
};
